import CollectionAdmin from "./CollectionAdmin";

export default function StaffAdmin() {
  return (
    <CollectionAdmin
      title="Ansatte"
      basePath="/api/admin/staff"
      fields={[
        { key: "name", label: "Navn", required: true },
        { key: "position", label: "Stilling", required: true },
        { key: "image", label: "Bilde (sti under public/)", required: true },
        { key: "description", label: "Beskrivelse", type: "multiline" },
      ]}
    />
  );
}
